import AppConstants from 'constants/AppConstants';

export function setSyndicate(syndicate: string) {
  return {
    type: AppConstants.SYNDICATE_SET,
    payload: {
      syndicate,
    },
  };
}

export function clear() {
  return {
    type: AppConstants.SYNDICATE_CLEAR,
  };
}
